"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _timelineIconHelper = require("crm_ui/timeline/helpers/timelineIconHelper");

var _timelineTitleHelper = require("crm_ui/timeline/helpers/timelineTitleHelper");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _get = _interopRequireDefault(require("transmute/get"));

var _TimelineBody = _interopRequireDefault(require("../generic/TimelineBody"));

var _TimelineHeader = _interopRequireDefault(require("../generic/header/TimelineHeader"));

var _getCompactEventOptions = require("../config/getCompactEventOptions");

var _toJS = _interopRequireDefault(require("transmute/toJS"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var propTypes = {
  timelineItem: _reactImmutableProptypes.default.mapContains({
    timestamp: _propTypes.default.number,
    eventData: _reactImmutableProptypes.default.mapOf(_propTypes.default.any, _propTypes.default.string),
    etype: _propTypes.default.string
  }).isRequired,
  subject: _SubjectType.default.isRequired
};

function TimelineCompactEvent(_ref) {
  var timelineItem = _ref.timelineItem,
      subject = _ref.subject;
  var objectType = (0, _ImmutableModel.getObjectType)(subject);

  var _getCompactEventOptio = (0, _getCompactEventOptions.getCompactEventOptions)(timelineItem, subject),
      bodyKey = _getCompactEventOptio.bodyKey,
      bodyOptions = _getCompactEventOptio.bodyOptions;

  var I18nComponent = bodyOptions && (0, _get.default)('useReact', bodyOptions) ? _FormattedReactMessage.default : _FormattedHTMLMessage.default;
  var bodyText = _I18n.default.lookup(bodyKey) ? _react.default.createElement(I18nComponent, {
    message: bodyKey,
    options: (0, _toJS.default)(bodyOptions)
  }) : null;
  return _react.default.createElement("div", null, _react.default.createElement(_TimelineHeader.default, {
    icon: (0, _timelineIconHelper.getTimelineIcon)(timelineItem, objectType),
    timestamp: (0, _get.default)('timestamp', timelineItem),
    typeTitle: (0, _timelineTitleHelper.getTimelineItemTitle)(timelineItem)
  }), bodyText && _react.default.createElement(_TimelineBody.default, null, bodyText));
}

TimelineCompactEvent.propTypes = propTypes;
var _default = TimelineCompactEvent;
exports.default = _default;
module.exports = exports.default;